import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Button, Table, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { Link, Prompt } from 'react-router-dom';
import Toggle from 'react-toggle';


// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import AdminService from '../../services/AdminService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';


const ApproveProvider = props => {

    // variables
    let timeout = 0;

    // states
    const [providers, setProviders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });

    const [viewDetailsModal, setViewDetailsModal] = useState({ isVisible: false });
    const [modalProviderDetails, setModalProviderDetails] = useState({});


    // contexts
    const { theme, colors, fontFamily } = useContext(ThemeContext);


    // useEffects
    useEffect(() => {
        getUnapprovedProviders();
    }, [pagination.page, pagination.limit, pagination.searchVal]);



    // utility functions
    const getUnapprovedProviders = async () => {
        try {
            setIsLoading(true);
            let data = await AdminService.getUnapprovedProviders(pagination.limit, pagination.page, pagination.searchVal);
            // console.log(data);
            setProviders([...data.providers]);
            if (data.pagination.totalPages <= data.pagination.page) {
                data.pagination.page = data.pagination.totalPages;
            }
            setPagination(data.pagination);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    }


    // handle functions
    const handleSearch = e => {
        try {
            let value = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, searchVal: value });
            }, 500);
        } catch (err) {
            console.log(err);
        }
    }


    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            console.log(err);
        }
    }


    const handleApproveProvider = async (index) => {
        try {
            let data = await AdminService.postApproveProvider(providers[index]._id);
            if (!data.message.msgError) {
                getUnapprovedProviders();
            }
        } catch (err) {
            console.log(err);
        }
    }

    
    const handleViewDetails = async (index) => {
        
        setModalProviderDetails({
            _id: providers[index]._id,
            isActive: providers[index].isActive,
            title: providers[index].title,
            firstName: providers[index].firstName,
            lastName: providers[index].lastName,
            email: providers[index].email,
            birthDate: providers[index].birthDate,
            gender: providers[index].gender,
            phone: providers[index].phone,
            address1: providers[index].address1,
            address2: providers[index].address2,
            pincode: providers[index].pincode,
            city: providers[index].city,
            state: providers[index].state,
            country: providers[index].country,
            description: providers[index].description,
            providerUniqueId: providers[index].providerUniqueId,
            languages: providers[index].languages,
            specialities: providers[index].specialities,
            degrees: providers[index].degrees,
        });



        setViewDetailsModal({ isVisible: true });
    }


    // function's return
    return(
        <main>
            <div className='container-fluid'>
                <div className='my-4'>
                    <h3 className='my-auto'>Approve Providers</h3>

                    {
                        isLoading
                        ? null
                        : 
                        <div className="card my-4">
                            <div className="card-header">
                                Pending Approvals for Providers
                            </div>
                            <div className="card-body py-0">
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                        <thead>
                                            <tr>
                                                <td colSpan="6" className="border-0 px-0">
                                                    <div className="d-flex">
                                                        <div className="ml-auto">
                                                            Search<input type="text" id="searchInput" className="ml-2" style={{ marginRight: "-20px", paddingRight: "20px" }} onChange={handleSearch}></input>
                                                            <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("searchInput").value = ""; setPagination({ ...pagination, searchVal: "" }); }}><i className="fa fa-times"></i></span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Details</th>
                                                <th>Approve</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                providers.map((item, index) => (
                                                    <ErrorBoundary errorAt={`At Admin Approve Providers Table${index}`}>
                                                        <tr key={index}>
                                                            <td>{`${item.title} ${item.firstName} ${item.lastName}`}</td>
                                                            <td>{item.email}</td>
                                                            <td align="center"><a style={{ color: "#384E73" }} href="#" onClick={() => handleViewDetails(index)}>View details</a></td>
                                                            <td align="center"><Button style={theme.button} onClick={() => handleApproveProvider(index)}>Approve</Button></td>
                                                        </tr>
                                                    </ErrorBoundary>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="6" className="border-0 pb-0 px-0">
                                                    <div className="d-flex">
                                                        <ErrorBoundary errorAt="At Admin Approve Providers Pagination">
                                                            <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                            <Pagination aria-label="Page navigation example" className="ml-auto">
                                                                <PaginationItem disabled={pagination.page == 1}>
                                                                    <PaginationLink
                                                                        onClick={e => handlePagination(e, pagination.page - 1)}
                                                                        previous
                                                                        href="#" />
                                                                </PaginationItem>
                                                                {[...Array(pagination.totalPages)].map((page, i) =>
                                                                    <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                        <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                            {i + 1}
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                )}
                                                                <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                                    <PaginationLink
                                                                        onClick={e => handlePagination(e, pagination.page + 1)}
                                                                        next
                                                                        href="#" />
                                                                </PaginationItem>
                                                            </Pagination>
                                                        </ErrorBoundary>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    }

                </div>

            </div>


            <Modal size="lg" isOpen={viewDetailsModal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => { setViewDetailsModal({ isVisible: false }); setModalProviderDetails({}); }}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Providers Details</span></ModalHeader>

                <ModalBody>
                    
                
                    <h3 className='mt-3' style={theme.paragraphHeading}>Provider</h3>
                    <Table borderless className="mt-4" id="modal-provider-details" style={{fontFamily: fontFamily.primary}}>
                        <tbody>
                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Id</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails._id}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '10rem', width: '18rem' }}>
                                    <span>Active</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.isActive ? "Active" : "Not Active"}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Name</span>
                                </td>
                                <td>
                                    <span>{`${modalProviderDetails.title} ${modalProviderDetails.firstName} ${modalProviderDetails.lastName}`}</span>
                                </td>
                            </tr>
                           
                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Email</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.email}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Unique Id</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.providerUniqueId}</span>
                                </td>
                            </tr>


                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Contact Number</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.phone}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Description</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.description}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Birth Date</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.birthDate}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Gender</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.gender}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Address line 1</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.address1}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Address line 2</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.address2}</span>
                                </td>
                            </tr>
                            
                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Pincode</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.pincode}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>City</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.city}</span>
                                </td>
                            </tr>
                            
                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>State</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.state}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Country</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.country}</span>
                                </td>
                            </tr>

                            {/* <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Languages</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.languages}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Specialities</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.specialities.join(', ')}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ minWidth: '8rem', width: '8rem' }}>
                                    <span>Degrees</span>
                                </td>
                                <td>
                                    <span>{modalProviderDetails.degrees.join(', ')}</span>
                                </td>
                            </tr> */}


                        </tbody>
                    </Table>



                </ModalBody>
            </Modal>

            

        </main>
    )


}

export default ApproveProvider;